import {
  ASSET_PAGES,
  CUSTOMER_PAGES_BASE,
  CUSTOMER_PAGES_ADVANCED,
  SITE_PAGES_BASE,
  SITE_PAGES_WITH_ASSETS,
} from "./pages"

const CUSTOMER_PAGES = { ...CUSTOMER_PAGES_BASE, ...CUSTOMER_PAGES_ADVANCED }
const SITE_PAGES = { ...SITE_PAGES_BASE, ...SITE_PAGES_WITH_ASSETS }

const CUSTOMER_PATHS: string[] = Object.keys(CUSTOMER_PAGES)
const SITE_PATHS: string[] = Object.keys(SITE_PAGES)
const ASSET_PATHS: string[] = Object.keys(ASSET_PAGES)

export const routing = (
  route: string,
  location: string,
  customerId?: string,
  siteId?: string,
  assetId?: string,
  systemId?: string,
  back: boolean = false,
  page?: string
) => {
  let path = route
  const endOfPath = location.split("/").pop()

  const addCustomerRoute = customerId && (!back || !(back && !siteId) || !(back && !assetId))
  if (addCustomerRoute) {
    if (!path.endsWith("/")) path += "/"

    path += `${customerId}`

    const addSiteRoute = siteId && !(back && !assetId)
    if (addSiteRoute) {
      path += `/sites/${siteId}`

      if (assetId && !back) {
        path += `/assets/${assetId}`
      }

      if (systemId && !back) {
        path += `/systems/${systemId}`
      }
    }
  }

  const paths = [...(assetId ? ASSET_PATHS : siteId ? SITE_PATHS : customerId ? CUSTOMER_PATHS : [])]
  if (!back && typeof page !== "string" && endOfPath && paths.includes(endOfPath)) {
    return path + "/" + endOfPath
  }

  if (page) {
    return path + "/" + page
  }

  return path
}
